
import { $ } from "./helpers";

const THEMES = ["dark", "light"];
export const PALLETE = ['#0B0E33', '#1A1B4B', '#2D205F', '#452A6F', '#60326F', '#7B3A6E', '#964268']; // ['#091236', '#1A1B4B', '#453A7D', '#8E3DA0', '#C44982']
export const palleteStr = PALLETE.join(', ');

// by default set to dark mode
getTheme(true);

function getTheme(init) {
    let pref = localStorage.getItem("theme");
    if (!pref) {
        init && setTheme(0);

        let prefLight = window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches;
        pref = prefLight ? "light" : "dark";
    }

    return pref;
}


export function changeTheme(){
    const theme = getTheme();
    const newTheme = THEMES.indexOf(theme) ? 0 : 1;
    setTheme(newTheme)

}

function setTheme(isLightTheme){
    const html = $("qhtml"), scheme = getColScheme(), newTheme = THEMES[isLightTheme];

    if (isLightTheme) {
        scheme.content = "light";
        html.classList.remove("dark-mode");
    } else {
        scheme.content = "light dark";
        html.classList.add("dark-mode");
    }

    try {
        localStorage.setItem("theme", newTheme)
    } catch (err) {
        console.error(err)
    }

    return newTheme
}

function getColScheme(){
    let head = document.head, scheme = document.querySelector("meta[name=color-scheme]");

    if (!scheme){
        scheme = document.createElement('meta');
        scheme.setAttribute('name', "color-scheme");
        head.appendChild(scheme);
    }
    return scheme;
}